import { storefront } from './sections/storefront.en';
import { account } from './sections/account.en';
import { admin } from './sections/admin.en';

export const en = { ...storefront, ...account, ...admin };
